import { Component } from '@angular/core';

@Component({
  selector: 'app-pharmacy-view',
  templateUrl: './pharmacy-view.component.html',
  styleUrls: ['./pharmacy-view.component.css']
})
export class PharmacyViewComponent {

}
